import { FlagOutlined } from '@ant-design/icons';
import React from 'react';
import { Popover } from 'antd';
import { IBook } from '../../../section/Common/types/types';
import { ACTIONS, useActions } from '../../../context/Actions.context';
import { GAEventIdentifier, GAEventName } from '../../../section/Common/constants';

interface IProps {
  book: IBook;
  id: string;
  label?: string;
}

const ToPendingExclusion: React.FC<IProps> = ({ book, id, label = 'Title' }) => {
  const { setAction } = useActions();

  return (
    <Popover
      placement='topLeft'
      content={<div className='popover-content'>{`Send ${label} to Pending Exclusion`}</div>}
      trigger='hover'
    >
      <FlagOutlined
        data-testid='action-pending-list'
        onClick={(e) => {
          e.stopPropagation();
          globalThis.gtag('event', GAEventName.click, {
            identifier: GAEventIdentifier.titletoPendingExclusion,
            value: book.ASIN,
            book_name: book.Title
          });
          setAction({ book, id, type: ACTIONS.pendingExclusion });
        }}
        className='actions-icons actions-icons-flag'
      />
    </Popover>
  );
};

export default React.memo(ToPendingExclusion);